<template>
  <div class="form__input" :class="{ 'form__input--error': !!error }">
    <label v-if="label" :for="id" :class="labelClasses">
      {{ label }}
    </label>
    <input
      :id="id"
      :type="type"
      :value="value"
      :class="inputClasses"
      v-bind="$attrs"
      @input="(e) => $emit('input', e.target.value)"
      @change="(e) => $emit('change', 'input', e.target.value)"
      @blur="$emit('blur')"
    />
    <p v-show="error" :class="errorClasses">
      {{ error }}
    </p>
  </div>
</template>

<script>
const isType = (t, e) => Object.prototype.toString.call(e) === `[object ${t}]`;
const isString = (e) => isType('String', e);
const isArray = (e) => isType('Array', e);
const isObject = (e) => isType('Object', e);

const mergeClasses = (def, override = {}) => {
  if (isString(override)) {
    override = override.split(' ');
  }
  if (isArray(override)) {
    override = override.reduce((a, e) => {
      a[e] = true;
      return a;
    }, {});
  }
  return isObject(override) ? { ...def, ...override } : def;
};

export default {
  $_veeValidate: {
    name() {
      return this.label;
    },
    value() {
      return this.value;
    }
  },

  props: {
    id: {
      type: String,
      required: true
    },

    type: {
      type: String,
      default: () => 'text'
    },

    value: {
      type: String,
      default: () => null
    },

    label: {
      type: String,
      default: () => ''
    },

    error: {
      type: String,
      default: () => null
    },

    labelClass: {
      type: [String, Array, Object],
      default: () => {}
    },

    inputClass: {
      type: [String, Array, Object],
      default: () => {}
    },

    errorClass: {
      type: [String, Array, Object],
      default: () => {}
    }
  },

  computed: {
    labelClasses() {
      return mergeClasses(
        {
          form__label: true
        },
        this.labelClass
      );
    },

    inputClasses() {
      return mergeClasses(
        {
          input: true,
          input__error: !!this.error,
          'has-input': this.value !== ''
        },
        this.inputClass
      );
    },

    errorClasses() {
      return mergeClasses(
        {
          form__error: true
        },
        this.errorClass
      );
    }
  }
};
</script>

<style lang="scss" scoped>
input {
  &::placeholder {
    color: white;
    opacity: 0.4;
  }

  &:-ms-input-placeholder {
    color: white;
    opacity: 0.4;
  }

  &::-ms-input-placeholder {
    color: white;
    opacity: 0.4;
  }
}
</style>
